import {vnToLatin} from "./common/Accent";
import {DateUtils} from "./common/DateUtils";
import {AjaxAPI} from "./common/AjaxAPI";
import {CalEvent} from "./model/CalEvent";
import {CalAttendeeType} from "./model/CalAttendeeType";
import {CalConfigItem, CalConfigs} from "./CalConfigs";
import {CalType} from "./model/CalType";
import {CalCategory} from "./model/CalCategory";
import {CalCategoryIcon} from "./model/CalCategoryIcon";
import {CalAttendeeRole} from "./model/CalAttendeeRole";
import {CalSubType} from "./model/CalSubType";
import {CalMode} from "./model/CalMode";
import {CalendarCar} from "./CalendarCar";
import {DictionaryData, SubFirmDictionary} from "./subfirm/Dictionary";
import {CalAttendeeState} from "./model/CalAttendeeState";
import {CalAttendee} from "./model/CalAttendee";
import {LEADER_REFERENCE} from "./CalConstants";
import * as _moment from 'moment';

const moment = _moment;

declare let iNet: any;
declare let $: any;

export class CalBuilder {
  isAuth: boolean = false;
  orgid: string = '';
  TIME_NEW_UPDATE: number = 12;
  roleUrl: string = 'xschedule/page/role';

  MODE = CalMode;
  ROLE = CalAttendeeRole;
  calSubType = CalSubType;
  calCategory = CalCategory;
  vnToLatin = vnToLatin;
  dateUtils = DateUtils;
  calAttendeeType = CalAttendeeType;
  calAttendeeState = CalAttendeeState;
  calType = CalType;

  subFirmDic = new SubFirmDictionary();
  carUtils = new CalendarCar(this.subFirmDic);

  configs = CalConfigs;

  resources = {
    days: [
      'Chủ nhật',
      'Thứ hai',
      'Thứ ba',
      'Thứ tư',
      'Thứ năm',
      'Thứ sáu',
      'Thứ bảy'
    ],
    statuses: [
      'Mới tạo',
      'Ban hành',
      'Chờ duyệt',
      'Đã hủy',
      'Thông qua',
      'Lịch đơn vị khác'
    ],
    allDay: 'Cả ngày',
    hour: 'giờ',
    minute: 'phút'
  };

  _userRoles: any = {};
  _mapEvents: any = {};
  _cacheStore: any;
  _queue: any = {};

  _organs: any[] = [];
  _myOrgans: any[] = [];

  _applyConfig() {
    iNet.apply(this, DateUtils);

    // Apply config
    // @ts-ignore
    const xCalendarConfigList: any = window['xCalendarConfigList'];
    if (xCalendarConfigList && xCalendarConfigList.length > 0) {
      xCalendarConfigList.forEach((config: any) => {
        let obj = this.getConfigObj(config.name);
        if (obj) {
          $.extend(obj, config);
        } else {
          this.configs.push(config);
        }
      });
    }
    // @ts-ignore
    const xCalendarConfigCustoms: any = window['xCalendarConfigCustoms'];
    if (xCalendarConfigCustoms) {
      for (let k in xCalendarConfigCustoms) {
        let obj = this.getConfigObj(k);
        if (obj) {
          obj.value = xCalendarConfigCustoms[k];
        }
      }
    }

    // Apply resources
    // @ts-ignore
    const xcalendarResources = window['xcalendarResources'];
    if (xcalendarResources) {
      this.resources = xcalendarResources;
    }

    this.configs.forEach(function (obj) {
      if (obj.value === 'false') {
        obj.value = false;
      }
    });
  }

  typeIsDepartment = (type: string) => type === CalType.DEPARTMENT;

  typeIsCommunity = (type: string) => type === CalType.COMMUNITY;

  typeIsOrganization = (type: string) => type === CalType.ORGANIZATION;

  catIsInvitation = (category: string) => CalCategory.INVITATION === category;

  catIsPersonal = (category: string) => CalCategory.PERSONAL === category;

  catIsCar = (category: string) => CalCategory.CAR === category;

  catIsImportant = (category: string) => CalCategory.IMPORTANT === category;

  formatDateStr = (date: any) => this.formatDate(date, this.getConfigValue('DATE_FORMAT'));

  formatTimeStr = (date: any) => this.formatDate(date, this.getConfigValue('TIME_FORMAT'));

  formatDateTimeStr = (date: any) => this.formatDate(date, this.getConfigValue('DATE_TIME_FORMAT'));

  formatDate = (date: any, format: string) => moment(date).format(format);

  getConfigValue(name: string) {
    let obj = this.getConfigObj(name);
    return obj && obj.value;
  }

  getConfigObj(name: string): CalConfigItem | null {
    for (let i = 0; i < this.configs.length; i++) {
      if (this.configs[i].name === name) {
        return this.configs[i];
      }
    }
    return null;
  }

  addQueue(name: any, executor: any, callback: any) {
    if (this._queue && this._queue[name]) {
      this._queue[name] = this._queue[name] || [];
      this._queue[name].push(callback);
      if (this._queue[name].length === 1) {
        new Promise((resolve) => {
          executor(resolve);
        }).then((value) => {
          this._queue[name].forEach((fn: Function) => {
            fn && fn(value);
          });
          delete this._queue[name];
        });
      }
    }
  }

  ready(callback: Function, options?: any) {
    this._loadOrgans((organs: any) => {
      callback(organs, this._getOrganOnInit());
    }, options);
  }

  // Cache all org in a minute for performance
  cacheSessionStorage(key: string, value?: any) {
    try {
      if (!value) {
        // Cache data in a minute
        let timeCache: number = 5 * 60000;
        let cache: any = sessionStorage.getItem(key);
        if (cache) {
          cache = JSON.parse(cache);
          if (new Date().getTime() - cache.time < timeCache) {
            return cache.data;
          } else {
            sessionStorage.removeItem(key);
          }
        }
        return false;
      } else {
        sessionStorage.setItem(key, JSON.stringify({
          time: new Date().getTime(),
          data: value
        }));
      }

      // Fixed prev version
      localStorage.removeItem(key);
    } catch (e) {
    }
  }

  // Cache data on global window, refresh tab will reset
  cacheDataTemp(key: any, data?: any) {
    this._cacheStore = this._cacheStore || {};
    if (data === undefined) {
      return this._cacheStore[key];
    } else {
      this._cacheStore[key] = data;
    }
  }

  setOrgId(orgid: string) {
    this.orgid = orgid;
    this._cacheOrgId(orgid);
  }

  getOrgId() {
    return this.orgid || this._cacheOrgId() || iNet.organId;
  }

  // @ts-ignore
  _cacheOrgId(orgid?: any) {
    let id = 'xcalendar_orgid';
    try {
      if (!orgid) {
        return localStorage.getItem(id);
      } else {
        localStorage.setItem(id, orgid);
      }
    } catch (e) {
    }
  }

  getHourMinute(date?: any) {
    if (date.getTime) {
      // date object
      return date.getHours() * 60 + date.getMinutes();
    } else {
      // string hour
      date = date.split(':');
      return Number(date[0]) * 60 + Number(date[1]);
    }
  }

  create(form: any, success: Function, options?: any) {
    return this.postForm({
      url: 'calbuilder/element/create',
      data: form,
      success: (event: any) => {
        if (event && event.uuid)
          this.indexEvent(event);
        success(event);
      }
    }, options);
  }

  updateEventByRole(params: any, success: Function, options?: any) {
    let organId = params && params.orgid || this.getOrgId();
    this.loadRole(organId, () => {
      let event = this.getEventByObjectId(params && params.element);
      if (this.isReviewer(organId)) {
        this.reviewUpdate(params, success, options);
      } else if (this.isOwnReviewer(organId) && event && this.meIsCreator(event)) {
        this.ownerReviewUpdate(params, success, options);
      } else {
        this.update(params, success, options);
      }
    }, options);
  }

  update(form: any, success: Function, options?: any) {
    return this.postForm({
      url: 'calbuilder/element/update',
      data: form,
      success: (event: any) => {
        if (event && event.uuid)
          this.indexEvent(event);
        success && success(event);
      }
    }, options);
  }

  reviewUpdate(form: any, success: Function, options?: any) {
    return this.postForm({
      url: 'calbuilder/reviewupdate',
      data: form,
      success: (event: any) => {
        if (event && event.uuid)
          this.indexEvent(event);
        success && success(event);
      }
    }, options);
  }

  ownerReviewUpdate(form: any, success: Function, options?: any) {
    return this.postForm({
      url: 'calbuilder/owner/reviewupdate',
      data: form,
      success: (event: any) => {
        if (event && event.uuid)
          this.indexEvent(event);
        success && success(event);
      }
    }, options);
  }

  remove(params: any, callback: Function, options?: any) {
    return this.sendRequest({
      url: 'calbuilder/element/delete',
      data: params,
      success: callback
    }, options);
  }

  cancel(params: any, success: Function, options?: any) {
    let organId = params && params.orgid || this.getOrgId();
    this.loadRole(organId, () => {
      if (this.isReviewer(organId)) {
        this.reviewCancel(params, success, options);
      } else if (this.isOwnReviewer(organId)) {
        this.ownerReviewCancel(params, success, options);
      }
    }, options);
  }

  // element, members
  reviewNotify(params: any, success: Function, options?: any) {
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/reviewnotify',
      data: params,
      success: success
    }, options);
  }

  reviewCancel(params: any, success: Function, options?: any) {
    return this.sendRequest({
      url: 'calbuilder/reviewcancel',
      data: params,
      success: (event: any) => {
        if (event && event.uuid)
          this.indexEvent(event);
        success && success(event);
      }
    }, options);
  }

  ownerReviewCancel(params: any, success: Function, options?: any) {
    return this.sendRequest({
      url: 'calbuilder/owner/reviewcancel',
      data: params,
      success: (event: any) => {
        if (event && event.uuid)
          this.indexEvent(event);
        success && success(event);
      }
    }, options);
  }

  deleteAttachment(params: any, success: Function, options?: any) {
    /**
     * fileID: 'id1,id2'
     * element: 'uuid'
     */
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/file/delete',
      data: params,
      success: (event: any) => {
        success && success(this.indexEvent(event));
      }
    }, options);
  }


  loadOrganMembers(organId: string, callback: Function, options?: any) {
    organId = organId || this.getOrgId();
    return this.searchAttendee({orgid: organId}, callback, options);
  }

  searchAttendee(params: any, success: Function, options?: any) {
    this._searchAttendee(params, function (members: any[]) {
      members.sort((a: any, b: any) => a.fullname.localeCompare(b.fullname));
      success(members);
    }, options);
  }

  _searchAttendee(params: any, success: Function, options?: any) {
    return this.sendRequest({
      url: 'calbuilder/attendee/search',
      data: params,
      success: (data: any) => {
        let members = data && data.elements || [];
        members = members.filter((item: any) => !item.alias);
        members.forEach((member: any) => this._indexAccount(member));
        success(members);
      },
      error: function () {
        success([]);
      }
    }, options, true);
  }

  _indexAccount(account: any) {
    // Remove suffix email before search user "binh@binhdinh.gov.vn"
    // don't search on suffix "@binhdinh.gov.vn"
    account['_index'] = vnToLatin(account.fullname.toLowerCase()) + ' ' +
      account.username.split('@')[0];
    account.display = this.insertPrefixAttendee(account.fullname || account.username);
    return account;
  }

  loadDepartments(params: any, callback: Function, options?: any) {
    return this.sendRequest({
      url: 'calbuilder/department/list',
      data: params,
      success: (data: any) => {
        data = data && data.items || [];
        data.sort((a: any, b: any) => {
          return a.order - b.order;
        });
        callback(data);
      },
      error: () => {
        callback([]);
      }
    }, options, true);
  }

  getMyOrg(callback: Function, options?: any) {
    let keyCache = 'cal_my_organs';

    // Remove data unused prev version
    localStorage.removeItem(keyCache);

    keyCache += iNet.usercode;

    this._myOrgans = this._myOrgans.length && this._myOrgans || this.cacheSessionStorage(keyCache) || [];
    if (this._myOrgans.length > 0) {
      return callback(this._myOrgans);
    }
    this.sendRequest({
      url: 'plugin/organization/list',
      success: (data: any) => {
        let organs = this._convertOrg(data && data.elements || []);
        if (organs.length > 0) {
          organs = this.visibleMyOrgans(organs);
          this._myOrgans = organs;
          this.cacheSessionStorage(keyCache, organs);
        }
        callback(organs);
      },
      error: () => callback([])
    }, options, true);

  }

  visibleMyOrgans(organs: any[]) {
    return organs.filter((organ: any) => {
      let _organ = this.getOrgById(organ.firmUUID);
      return _organ && !!_organ.groupType;
    });
  }

  getAllOrg(callback: any, options?: any): any {
    let keyCache = 'cal_organ_list';

    // Remove data unused prev version
    localStorage.removeItem(keyCache);

    keyCache += iNet.usercode;

    this._organs = this._organs.length && this._organs || this.cacheSessionStorage(keyCache) || [];
    // Check all org is cached
    if (this._organs.length > 0) {
      return callback(this._organs);
    }
    return this.sendRequest({
      data: {pageSize: -1},
      url: 'plugin/organization/search',
      success: (data: any) => {
        let organs = this._convertOrg(data && data.items || []);
        if (organs.length > 0) {
          // Only get organ has groupType
          organs = this.visibleOrgans(organs);
          this._organs = organs;
          this.cacheSessionStorage(keyCache, this._organs);
        }
        callback(organs);
      },
      error: () => callback([])
    }, options, true);
  }

  visibleOrgans(organs: any[]) {
    return organs.filter((organ) => !!organ.groupType);
  }

  private _loadOrgans(callback: Function, options?: any) {
    if (this._organs && this._organs.length > 0) {
      callback(this._organs.slice());
    } else {
      this.getAllOrg((organs: any[]) => {

        // Detect user login
        this.loadRole('', (role: any) => {
          this.isAuth = !!role.isAuth;
          if (role.isAuth) {
            this.getMyOrg((myOrgans: any[]) => {
              // Move my organs to first
              for (let i = myOrgans.length - 1; i >= 0; i--) {
                let myOrgan = myOrgans[i];
                for (let j = 0; j < organs.length; j++) {
                  let organ = organs[j];
                  if (organ.firmUUID === myOrgan.firmUUID) {
                    organs.splice(j, 1);
                    organ.myOrg = true;
                    organs.unshift(organ);
                    break;
                  }
                }
              }
              callback(organs);

            }, options);
          } else {
            callback(organs);
          }
        }, options);

      }, options);
    }
  }

  getTreeOrg(callback: Function, domain?: any) {
    this._loadOrgans((data: any) => {
      let tree: any = [];

      // Set children is empty
      data.forEach((item: any) => {
        item.children = [];
      });

      // Build tree org list
      data.forEach((item: any) => {
        if (item.parentID) {
          let parentOrgan = this.getOrgById(item.parentID);
          if (parentOrgan) {
            parentOrgan.children.push(item);
          }
        } else {
          tree.push(item);
        }
      });

      tree.data = data;
      callback && callback(tree);
    }, domain);
  }

  indexOrgSearch(item?: any) {
    item._index = vnToLatin([item.firmName, item.firmUUID, item.firmPrefix].join(' ').toLowerCase());
  }

  isMyOrg(orgid?: string) {
    if (orgid) {
      let org = this.getOrgById(orgid);
      return org && org.myOrg;
    }
  }

  loadEvent(params: any, callback: Function, options?: any) {
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/element/load',
      data: params,
      success: (data: any) => {
        if (!data || !data.uuid) {
          // Event not found, try to load review event
          this.loadRole(params.orgid, () => {
            if (this.isReviewer(params.orgid)) {
              this.loadEventReview(params, callback, options);
            } else {
              callback && callback(data);
            }
          });
          return;
        }
        this.indexEvent(data);
        callback && callback(data);
      }
    }, options);
  }

  updateState(params: any, callback: Function, options?: any) {
    if (params.notes) {
      params.notes = this.formatTextUpdate(params.notes);
    }
    return this.loadEvent(params, callback, options);
  }

  loadEventReview(params: any, success: Function, options?: any) {
    return this.sendRequest({
      url: 'calbuilder/reviewload',
      data: params,
      success: (event: any) => {
        if (event && event.uuid)
          this.indexEvent(event);
        success && success(event);
      }
    }, options);
  }

  loadGroupEvent(params: any, success: Function, options?: any) {
    return this.sendRequest({
      url: 'calbuilder/element/group',
      data: params,
      success: (data: any) => success(this.modifyEvent(data && data.items || []))
    }, options);
  }

  loadOrgEvents(params: any, callback: Function, options: any) {
    this._loadOnDifferYear(this._loadOrgEvents, params, callback, options);
  }

  _loadOrgEvents(params: any, callback: Function, options: any) {
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/mainboard/view',
      data: params,
      success: (data: any) => callback(this.modifyEvent(data && data.items || []))
    }, options);
  }

  loadCommunityEvents(params: any, callback: Function, options: any) {
    this._loadOnDifferYear(this._loadCommunityEvents, params, callback, options);
  }

  _loadCommunityEvents(params: any, callback: Function, options: any) {
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/mainboard/published',
      data: params,
      success: (data: any) => callback(this.modifyEvent(data && data.items || [])),
      useOrgId: true
    }, options);
  }

  loadAllPublishEvents(params: any, callback: Function, options: any) {
    this._loadOnDifferYear(this._loadAllPublishEvents, params, callback, options);
  }

  _loadAllPublishEvents(params: any, callback: Function, options: any) {
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/mainboard/published',
      data: params,
      success: (data: any) => callback(this.modifyEvent(data && data.items || [])),
      removeOrgId: true
    }, options);
  }

  loadPublishEvents(params: any, callback: Function, options?: any) {
    // Load role
    this.loadRole(params.orgid, () => {
      // Reviewer
      if (this.isMyOrg(params.orgid)) {
        this.loadOrgEvents(params, callback, options);
      } else {
        this.loadCommunityEvents(params, callback, options);
      }
    }, options);
  }

  getReviewEvents(params: any, callback: Function, options: any) {
    this._loadOnDifferYear(this._getReviewEvents, params, callback, options);
  }

  _getReviewEvents(params: any, callback: Function, options: any) {
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/reviewlist',
      data: params,
      success: (data: any) => callback(this.modifyEvent(data && data.items || []))
    }, options);
  }

  getViewEvents(params: any, callback: Function, options: any) {
    this._loadOnDifferYear(this._getViewEvents, params, callback, options);
  }

  _getViewEvents(params: any, callback: Function, options: any) {
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/viewlist',
      data: params,
      success: (data: any) => callback(this.modifyEvent(data && data.items || []))
    }, options);
  }

  reviewSearchEvents(params: any, callback: Function, options: any) {
    this._loadOnDifferYear(this._reviewSearchEvents, params, callback, options);
  }

  // members: ",,"
  _reviewSearchEvents(params: any, callback: Function, options: any) {
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/reviewsearch',
      data: params,
      success: (data: any) => callback(this.modifyEvent(data && data.items || []))
    }, options);
  }

  getOwnEvents(params: any, callback: Function, options?: any) {
    this._loadOnDifferYear(this._getOwnEvents, params, callback, options);
  }

  _getOwnEvents(params: any, callback: Function, options: any) {
    return this.sendRequest({
      type: 'post',
      url: 'calbuilder/element/list',
      data: params,
      success: (data: any) => callback(this.modifyEvent(data && data.items || []))
    }, options);
  }

  getListEvents(params: any, callback: any, options?: any): any {
    let promises: any = [];
    params.orgid = params.orgid || this.getOrgId();

    // Load review event
    this.loadRole(params.orgid, () => {
      // My events
      promises.push(new Promise((resolve) => {
        let _options = $.extend({}, options);
        _options.error = function () {
          resolve([]);
        };
        this.getOwnEvents(params, resolve, _options);
      }));

      if (this.isReviewer(params.orgid)) {
        // Reviewer
        promises.push(new Promise((resolve) => {
          let _options = $.extend({}, options);
          _options.error = function () {
            resolve([]);
          };
          this.getReviewEvents(params, resolve, _options);
        }));

      } else if (this.isViewer(params.orgid)) {
        // Viewer
        promises.push(new Promise((resolve) => {
          let _options = $.extend({}, options);
          _options.error = function () {
            resolve([]);
          };
          this.getViewEvents(params, resolve, _options);
        }));

      }

      // Load all promises
      Promise.all(promises).then((values) => {
        let events: any = [];
        values.forEach((value) => events = events.concat(value || []));
        events = this.removeEventDuplicate(events);
        callback(this.modifyEvent(events));
      });

    }, options);

  }

  modifyEvent(events: any) {
    if (!events)
      return;
    this.removeEventDuplicate(events);
    events.forEach((item: any) => this.indexEvent(item));
    this.sortEvents(events);
    return events;
  }

  removeEventDuplicate(events: any) {
    if (events.length > 1) {
      for (let i = 1; i < events.length; i++) {
        for (let j = i - 1; j >= 0; j--) {
          if (events[i].uuid === events[j].uuid && events[i].day === events[j].day) {
            events.splice(i, 1);
            --i;
            break;
          }
        }
      }
    }
    return events;
  }

  sortEvents(events: any) {
    // sort by start date
    this.sortEventStart(events);
    this.sortEventPriority(events);
    return events;
  }

  sortEventStart(events: any) {
    this._sort(events, 'from');
    return events;
  }

  sortEventPriority(events: any) {
    // sort by priority on day
    for (let i = 0; i < events.length; i++) {
      let item = events[i];
      item._order = Number(item._order) || 0;

      if (item._order > 0) {
        moveFirst(item);
        i = events.indexOf(item);
      }
    }

    function moveFirst(item: any) {
      if (item._order !== 0) {
        let index = events.indexOf(item);
        if (index > 0) {
          let tmp = events[index - 1];
          if (item.day === tmp.day && (tmp._order === 0 || item._order < tmp._order)) {
            events[index] = tmp;
            events[index - 1] = item;
            moveFirst(item);
          }
        }
      }
    }

    return events;
  }


  _sort(arr: any[], orderBy?: any) {
    for (let i = 1; i < arr.length; i++) {
      if (i === 0)
        continue;

      let item = arr[i],
        prev = arr[i - 1];

      if (item[orderBy] < prev[orderBy]) {
        arr[i] = prev;
        arr[i - 1] = item;
        i -= 2;
      }
    }
  }

  // keywords: string[]
  searchEventsByKeywords(events: any, keywords: any[]) {
    if (keywords && keywords.length > 0) {
      return events.filter((event: any) => {
        for (let i = 0; i < keywords.length; i++) {
          if (event._index.indexOf(keywords[i]) < 0) {
            return false;
          }
        }
        return true;
      });
    }
    return events.slice();
  }

  indexEvent(event: any) {
    // Save event with link to get later
    event.objectId = event.uuid + event.mode + event.day;
    this._mapEvents[event.objectId] = event;
    this._mapEvents[event.uuid] = event;

    if (!event._indexed) {

      this.indexEventMembers(event);
      // @ts-ignore
      const beforeIndexEvent = window['beforeIndexEvent'];
      if (beforeIndexEvent) {
        beforeIndexEvent(event);
      }

      event.subjectDisplay = this.formatTextDisplay(event.subject || '');
      event.locationDisplay = this.formatTextDisplay(event.location || '');

      this.indexRepeat(event);
      this.indexEventAttribute(event);
      this.indexEventDate(event);
      this.indexEventSearch(event);
      this.indexCustom(event);

      event.category = event.category || '';
      // @ts-ignore
      event.categoryIcon = CalCategoryIcon[event.category];

      event.department = event.departID;

      event._indexed = true;
    }
    return event;
  }

  indexEventMembers(event: any) {
    let obj: any = {};

    for (let k in CalAttendeeRole) {
      obj[k] = [];
    }

    event.members = event.members || [];
    event.attendees = [];

    event.members.forEach((item: any) => {

      item.name = this.attendeeDisplay(item);
      item.value = this.attendeeValue(item);

      // Type attendee
      if (item.alias) {
        item.type = CalAttendeeType.ALIAS;
      } else if (item.username) {
        item.type = CalAttendeeType.USER;
      } else {
        item.type = CalAttendeeType.ORGAN;
      }

      obj[item.role] = obj[item.role] || [];
      obj[item.role].push(item);

      if (item.role === CalAttendeeRole.CREATOR) {
        event.creator = item.username;
        event.fullname = item.fullname;
        event.isCreator = this.usernameIsMe(event.creator);
        event.creatorStr = event.fullname + '(' + event.creator + ')';
      } else {
        event.attendees.push(item);
      }
    });

    event.chairmanStr = this._groupMember2String(obj.CHAIRMAN);
    event.memberStr = this._groupMember2String(obj.MEMBER);

    // Todo: test prepare str
    event.prepareStr = this._groupMember2String(obj.PREPARER);
    event.watcherStr = event.observerStr = this._groupMember2String(obj.OBSERVER);

    event.membersDecode = obj;
  }

  _groupMember2String(members: any[]) {
    let str = '';
    let data: any = this.groupAttendeeByOrgan(members);
    for (let k in data) {
      let items = data[k];
      let organ = items.filter((item: any) => item.type === CalAttendeeType.ORGAN)[0];
      if (organ) {
        str += '<b>' + organ.organName + '</b>: ';
      }
      // Todo: consider to use this.buildMemberShow
      items.forEach((item: any) => {
        if (item.type !== CalAttendeeType.ORGAN) {
          str += item.name + ', ';
        }
      });
      str = str.slice(0, -2);
      str += '<br>';
    }
    return str.slice(0, -4);
  }

  indexEventAttribute(event?: any) {
    for (let k in event.attribute) {
      event['_' + k] = event.attribute[k];
    }
    event._order = Number(event._order) || 0;

    if (event._subType) {
      event.type = event._subType;
    }
  }

  initEvent(calEvent: any) {
    calEvent = $.extend({}, calEvent);
    this._initEventDate(calEvent);
    calEvent.startTime = calEvent.from.format('H:i');
    calEvent.toTime = calEvent.to.format('H:i');
    return calEvent;
  }

  _initEventDate(event: CalEvent | any) {
    if (event) {
      let date;
      if (event && event.uuid) {
        date = new Date(event.year, 0, event.day);
        if (date.getTime()) {
          event.from = new Date(date.getTime() + event.startTime * 60 * 1000);
          event.to = new Date(date.getTime() + event.toTime * 60 * 1000);
        }
      }
      if (!date || !date.getTime()) {
        date = new Date();
        date.setHours(date.getHours() + 1, 0, 0, 0);
        event.from = date;
        date = new Date(date);
        date.setHours(date.getHours() + 1);
        event.to = date;
      }
    }
  }

  indexEventDate(event: any) {
    this._initEventDate(event);

    // all day event
    event.allDay = event._allday === 'true';

    event.timeStr = this.formatDateStr(event.from);
    if (event.allDay) {
      event.startTimeStr = event.toTimeStr = this.resources.allDay;
      event.hourStr = this.resources.allDay;
    } else {
      event.startTimeStr = this.formatTimeStr(event.from);
      event.toTimeStr = this.formatTimeStr(event.to);
      event.hourStr = event.startTimeStr + ' - ' + event.toTimeStr;
    }

    event.timeStr += '; ' + event.hourStr;

    event.start = event.from;
    event.end = event.to;

    // Time create and update
    if (event.createTime) {
      event.createDate = new Date(event.createTime);
      event.createDateStr = this.formatDateTimeStr(event.createDate);

    }
    if (event.updateTime) {
      event.updateDate = new Date(event.updateTime);
      event.updateDateStr = this.formatDateTimeStr(event.updateDate);
    }

    let hourUpdated = new Date().getTime() - (event.updateTime || event.createTime);
    hourUpdated /= (60 * 60 * 1000);
    if (hourUpdated < 0) {
      hourUpdated = 0;
    }
    if (hourUpdated <= this.TIME_NEW_UPDATE) {
      event.recentUpdated = true;
      event.lastUpdateStr = this.getTextForMinutes(hourUpdated * 60);
    }
  }

  indexEventSearch(event: any) {
    // Index data to search
    event._index = '';
    event._members = [];

    if (event.subject) {
      event._index = vnToLatin(event.subject.toLowerCase());
    }

    // Index location to search
    if (event.location) {
      event._index += ' ' + vnToLatin(event.location.toLowerCase());
    }

    for (let i = 0; i < event.members.length; i++) {
      let member = event.members[i];
      if (member.fullname)
        event._index += ' ' + vnToLatin(member.fullname.toLowerCase());
      if (member.username) {
        event._index += ' ' + member.username.toLowerCase();

        // attendee
        if (member.role !== CalAttendeeRole.CREATOR) {
          event._members.push(member.username);
        }
      }
    }

    // Attachments
    if (event.attachments) {
      event.attachments.forEach((file: any) => {
        file.orgid = event.firmUUID;
      });
    }
  }

  indexRepeat(event: any) {
    //"FREQ=WEEKLY;UNTIL=20170707;INTERVAL=1;BYDAY=MO"
    if (event.rrule) {
      let obj: any = {};
      event.rrule.split(';').forEach((item: any) => {
        item = item.split('=');
        if (item[0] === 'FREQ') {
          obj.type = obj.rrule = obj.rrmode = item[1];
        } else if (item[0] === 'BYDAY') {
          obj.wkdays = item[1].split(',');
        }
      });
      if (event.lstart) {
        obj.lstart = new Date(event.lstart);
      }
      if (event.until) {
        obj.until = new Date(event.until);
      }
      event.repeat = obj;
    }
  }

  // Custom index
  indexCustom(event: any) {

  }

  getEventStatus = (mode: any) => this.resources.statuses[mode];

  isReviewer(orgid?: any) {
    orgid = orgid || this.getOrgId();
    return this._userRoles[orgid] && !!this._userRoles[orgid].reviewer;
  }

  isOwnReviewer(orgid?: any) {
    orgid = orgid || this.getOrgId();
    return this._userRoles[orgid] && !!this._userRoles[orgid].own_reviewer;
  }

  isViewer(orgid?: any): any {
    orgid = orgid || this.getOrgId();
    return this._userRoles[orgid] && !!this._userRoles[orgid].viewer;
  }

  getQueryParams(query?: any) {
    let params: any = {};
    query = query || location.search;
    query.replace('?', '').split('&').forEach((item: any) => {
      if (item) {
        let equalIndex = item.indexOf('=');
        if (equalIndex > -1)
          params[item.slice(0, equalIndex)] = item.slice(equalIndex + 1);
      }
    });
    return params;
  }

  buildQueryString(params?: any) {
    let query = '';
    for (let k in params) {
      query += k + '=' + encodeURIComponent(params[k]) + '&';
    }
    return query.slice(0, -1);
  }

  getUserAvatar(usercode: string, domain?: any) {
    return AjaxAPI.getUrl('system/userprofile/photo', domain) +
      '?usercode=' + usercode + '&thumbnail=50';
  }

  getPermissionOnEvent(event: any, callback: Function, currentOrganId?: any, options?: any) {
    let mode = event.mode;
    if (this.isOther(mode)) {
      callback();
      return;
    }
    if (!event.uuid) {
      return callback({
        save: true,
        saveCreate: true
      });
    }

    currentOrganId = currentOrganId || this.getOrgId() || event.firmUUID;

    this.loadRole(currentOrganId, () => {

      this.indexEvent(event);

      let permissions: any = {};
      const canReview = this.isReviewer(currentOrganId) ||
        (this.isOwnReviewer(currentOrganId) && this.canOwnReviewEvent(event));
      const canReviewUpdate = !this.isCreate(mode) && !this.isCancel(mode) && canReview;
      if (event.firmUUID === currentOrganId) {
        const isEditMyEvent = this.canUpdateOwnEvent(event);

        if (event.type === CalSubType.PERSONAL && !this.getConfigValue('PERSONAL_CAN_PUBLISH')) {
          // Personal calendar
          permissions = {
            save: isEditMyEvent,
            delete: isEditMyEvent
          };
        } else {

          permissions = {
            save: isEditMyEvent || canReviewUpdate,
            approve: canReview && (this.isSent(mode) || isEditMyEvent),
            reject: canReview && this.isSent(mode),
            send: isEditMyEvent && !canReview,
            revert: (this.isSent(mode) && event.isCreator) ||
              ((this.isCancel(mode) || this.isPublish(mode)) && canReview),
            cancel: canReview && this.isPublish(mode),
            delete: isEditMyEvent
          };
        }

      } else {
        // External update attendees
        permissions = {};
        if (this.isPublish(event.mode) && this.hasFirmAttendee(event, currentOrganId) &&
          this.canExternalUpdateEvent(event, currentOrganId)) {
          permissions = {updateAttendee: true};
        }
      }
      permissions.print = true;
      permissions.exportInvitation = this.catIsInvitation(event.category) && event._templateId;

      callback(permissions);
    }, options);
  }

  canUpdateOwnEvent(event: CalEvent): boolean {
    if (event && event.mode && event.isCreator) {
      return this.isCreate(event.mode);
    }
    return false;
  }

  canReviewEvent(event: CalEvent): boolean {
    return this.isReviewer(event.firmUUID);
  }

  canOwnReviewEvent(event: CalEvent): boolean {
    return this.isOwnReviewer(event.firmUUID) && event.isCreator;
  }

  canUpdateAttendee(event: CalEvent, ownOrganId: string) {
    return this.isFirmEvent(event, ownOrganId) && (this.canUpdateOwnEvent(event) ||
      this.canOwnReviewEvent(event) ||
      this.canReviewEvent(event));
  }

  canExternalUpdateEvent(event: CalEvent, organId: string): boolean {
    if (event && event.mode) {
      return this.isPublish(event.mode) && !this.isFirmEvent(event, organId) && this.isReviewer(organId);
    }
    return false;
  }

  isFirmEvent(event: CalEvent, ownOrganId: string) {
    return event.firmUUID === ownOrganId;
  }

  isCreate = (mode: number) => mode === CalMode.CREATE;

  isPublish = (mode: number) => mode === CalMode.PUBLISH;

  isSent = (mode: number) => mode === CalMode.SENT;

  isCancel = (mode: number) => mode === CalMode.CANCEL;

  isOther = (mode: number) => mode === CalMode.OTHER;

  searchAnyAttendee(params: any, callback: Function, options?: any) {
    this.searchUserAsAttendee(params, (users: any[]) => {
      this.searchOrganAsAttendee(params, (orgs: any[]) => {
        orgs.forEach((org: any) => users.push(org));
        callback(users);
      });
    }, options);
  }

  searchUserAsAttendee(params: any, callback: Function, options?: any) {
    let organId = params.orgid || this.getOrgId();
    let organName = this.getOrgNameById(organId);
    this.loadOrganMembers(organId, (members: any[]) => {
      let keyword = params.keyword || '';
      let limit = params.limit || -1;
      let attendees = [];
      keyword = vnToLatin(keyword).toLowerCase();
      for (let i = 0; i < members.length; i++) {
        let member = members[i];

        if (!keyword || member._index.indexOf(keyword) > -1) {
          let attendee = this.memberToAttendee(member);
          attendee.organId = organId;
          attendee.organName = organName;
          attendees.push(attendee);

          if (limit > 0 && attendees.length >= limit) {
            break;
          }
        }
      }
      callback(attendees);
    }, options);
  }

  searchOrganAsAttendee(params: any, callback: Function, options?: any) {
    this.loadOrgByKeyword(params, (organs: any[]) => {
      callback(organs.map((organ: any) => this.organToAttendee(organ)));
    }, options);
  }

  insertPrefixAttendee(fullname: string) {
    if (this.getConfigValue('PREFIX_ATTENDEE_NAME')) {
      return this.getConfigValue('PREFIX_ATTENDEE_NAME') + fullname;
    }
    return fullname;
  }

  memberToAttendee(member: any): CalAttendee {
    return {
      username: member.username,
      fullname: member.fullname,
      display: this.insertPrefixAttendee(member.fullname),
      type: CalAttendeeType.USER
    }
  }

  organToAttendee(organ: any): CalAttendee {
    return {
      organId: organ.firmUUID,
      organName: organ.firmName,
      type: CalAttendeeType.ORGAN
    }
  }

  aliasToAttendee(alias: string, organId: string): CalAttendee {
    organId = organId || this.getOrgId();
    return {
      alias: alias,
      organId: organId,
      organName: this.getOrgNameById(organId),
      type: CalAttendeeType.ALIAS
    }
  }

  // Search user and orgs to select when create calendar
  loadAttendeeByName(params: any, callback: Function, options?: any): any {
    if (!params || !params.keyword)
      return callback([]);

    // Limit user search
    params.limit = params.limit || 5;

    this.loadUserByKeyword(params, (users: any[]) => {
      this.loadOrgByKeyword(params, (orgs: any[]) => {
        callback(users.concat(orgs));
      });
    }, options);
  }

  loadUserByKeyword(params: any, callback: Function, options?: any) {
    // Load all users and search on client
    this.searchAttendee({
      orgid: params.orgid
    }, (members: any[]) => {
      let users = [];
      let keyword = vnToLatin(params.keyword.toLowerCase());
      for (let i = 0; i < members.length; i++) {
        let user = members[i];
        if (user._index.indexOf(keyword) > -1) {
          users.push({
            name: user.fullname,
            value: user.username,
            type: CalAttendeeType.USER,
            member: user
          });

          if (users.length >= params.limit) {
            break;
          }
        }
      }
      callback(users);
    }, options);
  }

  loadOrgByKeyword(params: any, callback: Function, options?: any) {
    let data: any[] = [];
    this._loadOrgans((orgs: any[]) => {
      // Filter orgs match
      let key = vnToLatin(params.keyword).toLowerCase();
      for (let i = 0; i < orgs.length; i++) {
        let item = orgs[i];
        if (item._index.indexOf(key) > -1) {
          data.push(item);
          if (data.length >= params.limit)
            break;
        }
      }
      callback(data);
    }, options);
  }

  getFileUrl(item: any, domain?: string, event?: CalEvent) {
    if (!item)
      return '';
    let orgid = item.orgid || this.getOrgId();
    let _role = this._userRoles[orgid];
    let url;
    if (_role && _role.isAuth && this.isMyOrg(orgid)) {
      url = 'calbuilder/binary/view';
    } else if (event && this.hasFirmAttendee(event, this.getOrgId())) {
      orgid = this.getOrgId();
      url = 'calbuilder/binary/view';
    } else {
      url = 'calbuilder/mainboard/binary/view';
    }
    return this.getUrlByOrgId(url, orgid, domain) + '?fileID=' + item.uuid + '&element=' + item.folder + '&orgid=' + orgid;
  }

  getFileViewUrl(item: any, domain?: string, event?: CalEvent) {
    let url = this.getFileUrl(item, domain, event);
    if (item.file && item.file.slice(-3).toLowerCase() === "pdf") {
      url += '&view=pdf&t=' + new Date().getTime();
    }
    return url;
  }

  hasFirmAttendee(event: CalEvent, organId: string): boolean {
    if (event && organId && event.members) {
      for (let i = 0; i < event.members.length; i++) {
        let member = event.members[i];
        if (member.type === CalAttendeeType.ORGAN && member.organId === organId) {
          return true;
        }
      }
    }
    return false;
  }

  getOrgByUid(uuid: string) {
    for (let i = 0; i < this._organs.length; i++) {
      if (this._organs[i].uuid === uuid) {
        return this._organs[i];
      }
    }
  }

  getOrgById(orgId: string) {
    for (let i = 0; i < this._organs.length; i++) {
      if (this._organs[i].firmUUID === orgId) {
        return this._organs[i];
      }
    }
  }

  getOrgNameById(orgId: string) {
    let organ = this.getOrgById(orgId);
    return organ && organ.firmName || '';
  }

  getOrgByPrefix(prefix: string) {
    for (let i = 0; i < this._organs.length; i++) {
      if (this._organs[i].firmPrefix === prefix) {
        return this._organs[i];
      }
    }
  }

  getUrlByOrgId(url: string, orgid: string, domain?: any) {
    let item = this.getOrgById(orgid);
    return AjaxAPI.getUrl(url, domain, item && item.firmPrefix);
  }

  loadRole(orgid: string, callback: Function, options?: any) {
    orgid = orgid || this.getOrgId();

    if (this._userRoles[orgid]) {
      return callback(this._userRoles[orgid]);
    }

    this.sendRequest({
      url: this.roleUrl,
      data: {orgid: orgid},
      success: (data: any) => {
        try {
          data = JSON.parse(data);
          if (data.isAuth) {
            this._userRoles[orgid] = data;
            iNet.usercode = data.usercode;
          }
          callback(data);
        } catch (e) {
          callback({});
        }
      },
      error: () => {
        callback({});
      }
    }, options, true);
  }

  loadRoles(organIds: any[], callback: Function, options?: any) {
    let promises: any[] = [];
    organIds.forEach((organId) => {
      promises.push(new Promise((resolve => {
        this.loadRole(organId, resolve, options);
      })));
    });
    Promise.all(promises).then((values) => callback(values));
  }

  generateEventWeekView(events: any, date?: any, firstDay?: any) {
    let segEvents = [];
    let startWeek = DateUtils.getDateStartWeek(date, firstDay);
    for (let i = 0; i < 7; i++) {
      let dayOfYear = DateUtils.dayOfYear(startWeek);
      segEvents.push(this.generateEventView(
        events.filter((event: any) => {
          return event.day === dayOfYear;
        }),
        startWeek
      ));
      startWeek.setDate(startWeek.getDate() + 1);
    }
    return segEvents;
  }

  getLastUpdateSegEvents(segEvents: any) {
    let lastUpdate: any;
    segEvents.forEach((segEvent: any) => {
      segEvent.items.forEach((event: any) => {
        let lastUpdateEvent = event.updateDate || event.createDate;
        if (!lastUpdate || lastUpdate < lastUpdateEvent) {
          lastUpdate = lastUpdateEvent;
        }
      });
    });
    return lastUpdate;
  }

  generateEventView(events: any[], date: any) {
    date = new Date(date);
    return {
      day: DateUtils.dayOfYear(date),
      display: this.getDisplayByDay(date.getDay()),
      dayStr: this.formatDateStr(date),
      isToday: DateUtils.dateIsToday(date),
      date: date,
      items: events
    }
  }

  getDisplayByDay(day?: any) {
    return this.resources.days[day];
  }

  buildMembers(members: any, role?: any) {
    members.forEach((member: any) => member.role = role || CalAttendeeRole.MEMBER);
    return members;
  }

  groupAttendeeByOrgan(attendees: CalAttendee[]) {
    let data: any = {};
    attendees.forEach(function (attendee: any) {
      if (attendee && attendee.organId) {
        data[attendee.organId] = data[attendee.organId] || [];
        data[attendee.organId].push(attendee);
      }
    });
    return data;
  }

  groupAttendeeByOrganRole(event: CalEvent,
                           attendees: CalAttendee[],
                           ownOrganId: string,
                           callback: Function,
                           options?: any) {
    if (attendees.length < 1) {
      return callback([]);
    }

    let groupByOrgans = this.groupAttendeeByOrgan(attendees);
    let organIds = Object.keys(groupByOrgans);
    if (organIds.indexOf(ownOrganId) < 0) {
      organIds.push(ownOrganId);
    }
    this.loadRoles(organIds, () => {
      let internalUpdate = !event.uuid || this.canUpdateAttendee(event, ownOrganId);
      let data: any[] = [];

      Object.keys(groupByOrgans).forEach((organId) => {
        let isMyOrgan = organId === ownOrganId;
        let externalUpdate = isMyOrgan && this.canExternalUpdateEvent(event, organId);
        let attendees = groupByOrgans[organId];
        data.push({
          organId: organId,
          organName: this.getOrgNameById(organId),
          internalUpdate: internalUpdate,
          externalUpdate: externalUpdate,
          updateAttendee: internalUpdate || externalUpdate,
          attendees: attendees,
          canRemoveAttendee: function (attendee: any) {
            return internalUpdate || (externalUpdate && attendee.type !== CalAttendeeType.ORGAN);
          },
          canUpdateState: (attendee: any) => {
            return attendee.readTime !== undefined && isMyOrgan && this.attendeeIsMe(attendee);
          }
        });
      });
      callback(data);
    }, options);
  }

  buildMemberStr(item?: any) {
    item.members = item.members || [];
    return item.members.map((item: any) => item.name).join(',');
  }

  buildMemberShow(members: any[]) {
    return (members || []).map((item) => item.name).join(';');
  }

  modifyDataUpdate(data: any, event?: any) {
    let attendeeJson: any[] = [];
    // Remove all members and rebuild
    if (data.attendee) {

      let newAttendees = data.attendee.filter(function (attendee: any) {
        return attendee.readTime === undefined;
      });

      if (event && event.uuid) {
        let remainAttendees = data.attendee.filter(function (attendee: any) {
          return attendee.readTime !== undefined;
        });
        event.members.forEach((member: any) => {
          if (member.role !== CalAttendeeRole.CREATOR) {
            if (remainAttendees.indexOf(member) < 0) {
              attendeeJson.push(this.attendeeRemoveJson(member));
            }
          }
        });
      }

      newAttendees.forEach((attendee: any) => attendeeJson.push(this.attendeeAddJson(attendee)));
    }

    // Secure text update
    if (data.subject) {
      data.subject = this.formatTextUpdate(data.subject);
    }
    if (data.location) {
      data.location = this.formatTextUpdate(data.location);
    }

    data.attendee = JSON.stringify(attendeeJson);

    // Personal calendar
    if (!this.getConfigValue('PERSONAL_CAN_PUBLISH') && data.type === CalSubType.PERSONAL) {
      data.mode = CalMode.CREATE;
    }

    if (data.type === CalSubType.MEET_PEOPLE || data.type === CalSubType.PERSONAL) {
      data._subType = data.type;
      data.type = data.type.split(';')[0];
    } else {
      data._subType = '';
    }

    return data;
  }

  attendeeAddJson(attendee: CalAttendee) {
    let obj: any = {
      organId: attendee.organId,
      organName: attendee.organName,
      role: attendee.role || CalAttendeeRole.MEMBER
    };
    switch (attendee.type) {
      case CalAttendeeType.USER:
        obj.members = attendee.username + ':' + attendee.fullname;
        obj.display = attendee.display;
        break;
      case CalAttendeeType.ORGAN:
        if (this.getConfigValue('EVENT_BETWEEN_UNIT')) {
          obj.firms = attendee.organId + ':' + attendee.organName;
        }
        break;
      default:
        obj.alias = attendee.alias || attendee.organName;
    }
    return obj;
  }

  attendeeRemoveJson(attendee: CalAttendee) {
    let obj: any = {
      organId: attendee.organId
    };
    switch (attendee.type) {
      case CalAttendeeType.USER:
        obj.members = attendee.username + ':REMOVE';
        break;
      case CalAttendeeType.ORGAN:
        obj.firms = attendee.organId + ':REMOVE';
        break;
      default:
        obj.alias = attendee.alias + ':REMOVE';
    }
    return obj;
  }

  _convertOrg(data: any) {
    data = data || [];
    for (let i = 0; i < data.length; i++) {
      let item = data[i];
      item.firmName = item.orgName || item.name;
      item.firmPrefix = item.uriPrefix || item.prefix;
      item.firmUUID = item.organId || item.organiId || '';
      this.indexOrgSearch(item);
    }

    // sort by name
    data.sort((a: any, b: any) => {
      return a.firmName.localeCompare(b.firmName);
    });

    return data;
  }

  viewEventOnModal(objectId: any) {
    if (this._mapEvents[objectId]) {
      iNet.plugins.ready((plugins: any) => {
        if (plugins.xcalendar) {
          plugins.xcalendar.openView(this._mapEvents[objectId]);
        }
      });
    }
  }

  // Save and get event
  getEventByObjectId(objectId: any) {
    return this._mapEvents[objectId];
  }

  getTextForMinutes(minutes?: any) {
    minutes = parseInt(minutes) || 1;
    if (minutes >= 60) {
      return Math.round(minutes / 60) + ' ' + this.resources.hour;
    } else {
      return minutes + ' ' + this.resources.minute;
    }
  }

  groupEventBySession(events: any) {
    let data: any = {
      allday: [],
      morning: [],
      afternoon: [],
      evening: []
    };
    events.forEach((item: any) => {
      if (item.allDay) {
        data.allday.push(item);
      } else if (item.from.getHours() < 12) {
        data.morning.push(item);
      } else if (item.from.getHours() < 18) {
        data.afternoon.push(item);
      } else {
        data.evening.push(item);
      }
    });

    for (let k in data) {
      this.sortEvents(data[k]);
    }

    return data;
  }

  groupEventByPerson(events: any, persons: any, date: any) {
    let data: any = {
      persons: [],
      segEvents: this.generateEventWeekView(events, date)
    };
    let eventByDays = data.segEvents.map(function (segEvent: any) {
      return segEvent.items;
    });

    persons.forEach((person: any) => {
      let eventDays = eventByDays.map((events: any) =>
        events.filter((event: any) => this.memberIsAttendee(event, person.name)));
      data.persons.push({
        person: person,
        eventDays: eventDays
      });
    });

    return data;
  }

  groupEventByLeaders(events: CalEvent[], organId: string, callback: Function, options?: any) {
    this.loadLeaders(organId, (leaders: any[]) => {
      let dataLeaders: any[] = [];
      let otherEvents: any[] = [];
      leaders.forEach((leader) => dataLeaders.push({
        username: leader.name,
        fullname: leader.value,
        events: []
      }));
      events.forEach((event) => {
        let isFound;
        for (let i = 0; i < dataLeaders.length; i++) {
          let item = dataLeaders[i];
          if (this.memberIsAttendee(event, item.username)) {
            isFound = true;
            item.events.push(event);
          }
        }
        if (!isFound) {
          otherEvents.push(event);
        }
      });
      callback(dataLeaders, otherEvents);
    }, options, true);
  }

  meIsCreator(event: CalEvent): boolean {
    if (event && event.members) {
      for (let i = event.members.length - 1; i >= 0; i--) {
        if (event.members[i].role === CalAttendeeRole.CREATOR && this.attendeeIsMe(event.members[i])) {
          return true;
        }
      }
    }
    return false;
  }

  attendeeIsMe(attendee: CalAttendee): boolean {
    if (attendee && attendee.username) {
      return this.usernameIsMe(attendee.username);
    }
    return false;
  }

  attendeeDisplay(attendde: CalAttendee) {
    return attendde.alias || attendde.display || attendde.fullname || attendde.username || attendde.organName;
  }

  attendeeValue(attendde: CalAttendee) {
    return attendde.alias || attendde.username || attendde.organId;
  }

  formatTextDisplay(text: string) {
    let display = this.formatTextUpdate(text);

    // break line
    display = display.replace(/\n/g, '<br>');

    return display;
  }

  formatTextUpdate(text: string) {
    let $fragment = $('<div>').html(text);
    $fragment.find('style,script').remove();
    return $fragment.html();
  }

  memberIsAttendee(event: CalEvent, member: string): boolean {
    if (event && event.members) {
      for (let i = 0; i < event.members.length; i++) {
        if (event.members[i].username === member) {
          return true;
        }
      }
    }
    return false;
  }

  getAttendeeByUsername(event: CalEvent, username: string): CalAttendee | null {
    if (event && event.members) {
      for (let i = 0; i < event.members.length; i++) {
        if (event.members[i].username === username) {
          return event.members[i];
        }
      }
    }
    return null
  }

  getAttendeeIsMe(event: CalEvent): CalAttendee | null {
    if (event && event.members) {
      for (let i = 0; i < event.members.length; i++) {
        let member = event.members[i];
        if (member.username && member.role !== CalAttendeeRole.CREATOR && this.usernameIsMe(member.username)) {
          return member;
        }
      }
    }
    return null;
  }

  eventIsViewed(event: CalEvent) {
    let attendee = this.getAttendeeIsMe(event);
    return !attendee || attendee.readTime;
  }

  usernameIsMe(username: String): boolean {
    return username === iNet.usercode;
  }

  sendRequest(data: any, options?: any, cacheResponse?: any) {
    let option = this._buildAjaxOptions(data, options);
    if (cacheResponse) {
      let keyCache = option.url;
      if (option.data && Object.keys(option.data).length > 0) {
        keyCache += JSON.stringify(option.data);
      }
      let dataCached = this.cacheDataTemp(keyCache);
      if (dataCached) {
        return option.success(dataCached);
      }
      this.addQueue(keyCache, (resolve: any) => {
        let _option = $.extend({}, option);
        _option.success = (data: any) => {
          this.cacheDataTemp(keyCache, data);
          resolve(data);
        };
        _option.error = (error: any) => {
          resolve(null, error);
        };
        AjaxAPI.sendRequest(_option);
      }, (data: any, error: any) => {
        if (error) {
          option.error && option.error(error);
        } else {
          option.success && option.success(data);
        }
      });
    } else {
      return AjaxAPI.sendRequest(option);
    }
  }

  postForm(data: any, options?: any) {
    return AjaxAPI.postForm(this._buildAjaxOptions(data, options));
  }

  _buildAjaxOptions(data: any, options?: any) {

    let option = $.extend({}, data, options);
    let orgid = option.data && option.data.orgid || this.getOrgId();
    let org = this.getOrgById(orgid);
    let isLocalFirm = org && org.firmPrefix === iNet.path.slice(1);
    let isUseOrgId = !option.removeOrgId && (isLocalFirm || option.useOrgId);
    if (isUseOrgId) {
      option.data = option.data || {};
      option.data.orgid = orgid;
    } else if (option.data) {
      delete option.data.orgid;
    }
    option.url = this.getUrlByOrgId(option.url, orgid, option.domain);
    return option;
  }

  _getOrganOnInit() {
    let organ;

    let params = this.getQueryParams();

    // Get by url query
    if (params['orgid']) {
      this.setOrgId(params['orgid']);
      organ = this.getOrgById(params['orgid']);
    }

    // get organ by firm prefix
    if (!organ && iNet.firmPrefix !== 'smartcloud') {
      organ = this.getOrgByPrefix(iNet.firmPrefix);
    }

    // Get organ active recently
    if (!organ) {
      let organId = this.getOrgId() || iNet.organId;
      organ = this.getOrgById(organId);
    }

    // Get organ local
    if (!organ) {
      organ = this.getOrgByPrefix(iNet.path.slice(1));
    }

    // get organ first
    if (!organ) {
      organ = this._myOrgans && this._myOrgans[0] || this._organs && this._organs[0];
    }

    if (organ) {
      this.setOrgId(organ.firmUUID);
    }

    return organ;
  }

  groupEventByCar(cars: any, events: any) {
    let data: any[] = [];
    cars.forEach(function (car: any) {
      data.push({
        car: car,
        events: []
      });
    });

    events.forEach(function (event: any) {
      let carData = data[0];
      if (event._carUUID) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].car.uuid === event._carUUID) {
            carData = data[i];
          }
        }
      }
      carData.events.push(event);
    });

    return data;
  }

  filterMeetPeopleEvents(events: any[]) {
    return events.filter(function (event: any) {
      return event._subType === CalSubType.MEET_PEOPLE;
    });
  }

  _loadOnDifferYear(executor: any, params: any, callback: Function, options?: any) {
    if (!params.from || !params.to || params.from <= params.to) {
      executor.apply(this, [params, callback, options]);
    } else {
      // Load in differ year
      let promises = [];
      let endOfYear = new Date(params.year + 1, 0);
      endOfYear.setTime(endOfYear.getTime() - 1);

      let params1 = $.extend({}, params);
      let options1 = $.extend({}, options);
      params1.to = DateUtils.dayOfYear(endOfYear);
      promises.push(new Promise((resolve) => {
        executor.apply(this, [params1, resolve, options1]);
      }));

      let params2 = $.extend({}, params);
      let options2 = $.extend({}, options);
      params2.year = params.year + 1;
      params2.from = 1;
      promises.push(new Promise((resolve) => {
        executor.apply(this, [params2, resolve, options2]);
      }));

      Promise.all(promises).then((values: any[]) => {
        let events = [].concat.apply([], values);
        this.removeEventDuplicate(events);
        callback(events);
      });
    }
  }

  loadMonthEvents(params: any, date: any, callback: Function, options?: any) {
    let from, to;
    date = new Date(date);
    // Start month
    date.setDate(1);

    // Start date of week
    from = DateUtils.getDateStartWeek(date);

    // End month
    date.setMonth(date.getMonth() + 1);
    date.setTime(date.getTime() - 1);

    // End date of week
    to = DateUtils.getDateEndWeek(date);

    params = $.extend({}, params, this.getRangeParams(from, to));

    if (this.isMyOrg(params.orgid)) {
      this.getListEvents(params, callback, options);
    } else {
      this.loadPublishEvents(params, callback, options);
    }
  }

  // @ts-ignore
  getExportUrl(calEvent: any, domain: string) {
    if (calEvent && calEvent.uuid && calEvent._templateId) {
      return this.getUrlByOrgId('calbuilder/invitation/export', calEvent.firmUUID, domain) +
        '?templateID=' + calEvent._templateId +
        '&element=' + calEvent.uuid;
    }
  }

  getWeekParams(date: Date) {
    let weekRange = DateUtils.getWeekRange(date);
    return this.getRangeParams(weekRange.startWeek, weekRange.endWeek);
  }

  getRangeParams(from: Date, to: Date) {
    return {
      year: from.getFullYear(),
      from: DateUtils.dayOfYear(from),
      to: DateUtils.dayOfYear(to)
    }
  }

  dateEqualWeekParams(date: Date, weekParams: any) {
    let params = this.getWeekParams(date);
    return date && weekParams && params.year === weekParams.year &&
      params.from === weekParams.from &&
      params.to === weekParams.to;
  }

  eventIsOnRange(event: CalEvent, params?: any): boolean {
    if (event.startTime && event.toTime) {
      return (params.startTime >= event.startTime && params.startTime < event.toTime) ||
        (params.toTime <= event.toTime && params.toTime > event.startTime) ||
        (params.startTime <= event.startTime && params.toTime >= event.toTime);
    }
    return false;
  }

  verifyDuplicateEvents(params: any, callback: Function, options?: any) {
    let duplicateEvents: any[] = [];
    this.loadPublishEvents({
      year: params.year,
      day: params.day,
      orgid: params.orgid || this.getOrgId()
    }, (events: any[]) => {
      let allEvents: any[] = [];

      if (this.catIsCar(params.category)) {
        events = events.filter((event) => this.catIsCar(event.category));
      } else {
        events = events.filter((event) => !this.catIsCar(event.category));
      }

      const detector = (username: string) => {
        let obj: any = {
          username: username,
          events: []
        };

        events.forEach((event) => {
          let member = this.getAttendeeByUsername(event, username);
          if (member) {
            obj.fullname = member.fullname;
            obj.events.push(event);
            allEvents.push(event);
          }
        });

        if (obj.events.length > 0) {
          duplicateEvents.push(obj);
        }
      };
      events = events.filter((event) => {
        return event.mode === CalMode.PUBLISH && event.uuid !== params.element &&
          this.eventIsOnRange(event, params);
      });
      if (params.attendee) {
        params.attendee.forEach((attendee: any) => detector(attendee.username));
      }

      // Todo: creator is attendee
      let isExist = false;
      for (let i = 0; i < duplicateEvents.length; i++) {
        if (duplicateEvents[i].username === iNet.usercode) {
          isExist = true;
          break;
        }
      }
      if (!isExist) {
        detector(iNet.usercode);
      }
      this.removeEventDuplicate(allEvents);
      //duplicateEvents['allEvents'] = this.removeEventDuplicate(allEvents);

      callback(duplicateEvents);

    }, options);
  }

  needVerifyDuplicate(params: any, event: any) {
    var isEventPublished = event.mode === CalMode.PUBLISH;
    var actionPublish = !isEventPublished && Number(params.mode) === CalMode.PUBLISH;
    var isTimeChanged = event.uuid && (
      (params.startTime && event.startTime !== params.startTime) ||
      (params.toTime && event.toTime !== params.toTime) ||
      (params.day && event.day !== params.day)
    ) && isEventPublished;
    return actionPublish || isTimeChanged;
  }

  subjectDisplayWithMaxLength(event: any) {
    // Subject max length
    var maxLength = Number(this.getConfigValue('SUBJECT_DISPLAY_MAX_LENGTH')) || 0;
    // Display view more
    if (maxLength > 0 && maxLength < event.subject.length) {
      var subjectDisplay = event.subject.substr(0, maxLength);
      subjectDisplay = this.formatTextDisplay(subjectDisplay);
      subjectDisplay += '...';
      return this.formatTextDisplay(subjectDisplay);
    }
    return event.subjectDisplay;
  }

  // SubFirm Dictionary Utils
  dictCreate(data: DictionaryData, callback: Function, options?: any) {
    return this.sendRequest({
      type: 'post',
      url: 'subfirm/dictionary/create',
      data: data,
      success: callback
    }, options);
  }

  dictUpdate(data: DictionaryData, callback: Function, options?: any) {
    data.dictID = data.dictID || data.uuid;
    return this.sendRequest({
      type: 'post',
      url: 'subfirm/dictionary/update',
      data: data,
      success: callback
    }, options);
  }

  dictRemove(data: DictionaryData, callback: Function, options?: any) {
    data.dictID = data.dictID || data.uuid;
    return this.sendRequest({
      type: 'post',
      url: 'subfirm/dictionary/remove',
      data: data,
      success: callback
    }, options);
  }

  dictList(params: any, callback: Function, options?: any, cacheResponse?: boolean) {
    // reference: required
    return this.sendRequest({
      type: 'post',
      url: 'subfirm/dictionary/list',
      data: params,
      success: (data: any) => callback(data && data.items || []),
      error: () => callback([])
    }, options, cacheResponse);
  }

  // Leader
  loadLeaders(organId: string, callback: Function, options?: any, cacheResponse?: boolean) {
    let params = {
      orgid: organId || this.getOrgId(),
      reference: LEADER_REFERENCE
    };
    this.dictList(params, function (leaders: any[]) {
      leaders.sort(function (a: any, b: any) {
        return b.order - a.order;
      });
      callback(leaders);
    }, options, cacheResponse);
  }

  leaderCreateOrUpdate(data: DictionaryData, callback: Function, options?: any) {
    if (!data.uuid) {
      data.reference = LEADER_REFERENCE;
      this.dictCreate(data, callback, options);
    } else {
      this.dictUpdate(data, callback, options);
    }
  }

  leaderRemove(data: DictionaryData, callback: Function, options?: any) {
    this.dictRemove(data, callback, options);
  }
}
